import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  
  fetchHarvestProcess(organization_id, harvest_process_id) {
    return RequesterV1.get(
      `organization/process/harvest_export/show_exported_batch/${organization_id}/fetch_harvest_process/${harvest_process_id}`
    );
  },
  
  fetchExportedBatch(organization_id, exported_batch_id) {
    return RequesterV1.get(
      `organization/process/harvest_export/show_exported_batch/${organization_id}/fetch_exported_batch/${exported_batch_id}`
    );
  },
  
}
